// select2 のリモート候補取得(無限スクロール)の共通設定。
//
// 候補用 JSON(matters / contacts / places / users の index.json.jbuilder)は
// json.array! で素の配列を返すため、レスポンスに総件数がない。そのため
// 「続きがあるか」は「1ページ分ちょうど返ってきたか」でしか判定できない。
//
// 判定に必要な1ページの件数は、サーバーの既定値に依存すると簡単にズレる
// (実際、各所にコピーされた 30 という定数が実件数の 25/100 とズレたまま
// data.total_count(常に undefined)と比較しており、2ページ目が一度も
// 読み込まれない状態だった)。ここでは per をリクエストに載せ、送った値と
// 同じ値で判定することでズレようがない形にしている。
//
// サーバー側は ApplicationController#select2_per_page が per を受け取り、
// SELECT2_MAX_PER_PAGE(100)で丸める。per を送らない呼び出し元は従来の
// 件数のまま動く。
export const SELECT2_PER_PAGE = 30;

// url:   候補取得先
// query: select2 の検索状態から ransack の q を作る関数
// extra: q の外に出すクエリパラメータを作る関数(任意)
export function select2RemoteAjax({ url, query, extra, responseKey, resultTextKey }) {
  return {
    url,
    dataType: 'json',
    delay: 250,
    cache: true,

    data(params) {
      return Object.assign(
        {
          q: query(params),
          page: params.page,
          per: SELECT2_PER_PAGE
        },
        extra ? extra(params) : {}
      );
    },

    // 最終ページがちょうど per 件だった場合だけ、空のレスポンスを
    // 1回余分に取りにいく。実害はない。
    processResults(data) {
      const items = responseKey ? data[responseKey] : data;
      const results = (Array.isArray(items) ? items : []).map(item => (
        resultTextKey ? { ...item, text: item[resultTextKey] } : item
      ));

      return {
        results,
        pagination: {
          more: results.length >= SELECT2_PER_PAGE
        }
      };
    }
  };
}

// .js.erb / インラインスクリプトなど、import できない呼び出し元向け。
window.select2RemoteAjax = select2RemoteAjax;
